<template>
  <!-- scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-gray-600 scrollbar-track-gray-900 dark:scrollbar-track-gray-800 dark:bg-gray-900 overflow-auto -->
  <aside
    v-show="!isFullScreen"
    class="w-64 fixed top-0 z-40 h-screen bg-white dark:bg-gray-900 transition-all sidebar-parent duration-1000"
    :class="[ isAsideMobileExpanded ? '-left-64' : 'left-0', isAsideLgActive ? 'block' : 'lg:block' ]"
  >
    <div class="inner-sidebar">
      <div class="bg-top-sidebar transition-colors duration-1000" :class="darkMode ? 'bg-gray-400' : 'bg-white'">
        <div class="w-full h-auto">
          <!-- <show-image :imageName="schoolidentity.img" /> -->
          <img class="mx-auto h-10 w-auto" v-if="schoolidentity.img" :src="schoolidentity.img" alt="Status No Aktif">
        </div>

        <div class="w-full h-auto p-2 mt-4 transition-colors duration-1000" :class="darkMode ? 'bg-gray-400' : 'bg-sch-name'">
          <div class="school-sidebar transition-colors  duration-1000" :class="darkMode ? 'bg-darkmode-hard' : 'bg-white'">
            <!-- <div class="img-sch">
              <img src="../assets/cc.png" alt="School">
            </div> -->
            <div class="name-sch">
              <!-- SCHOOL NAME -->
              {{ schoolidentity.name }}
            </div>
          </div>
        </div>
      </div>

      <div class="menu-sidebar transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-hard' : 'bg-white'">
        <template v-for="(menuGroup, index) in menu">
          <p v-if="typeof menuGroup === 'string'" :key="`a-${index}`" class="hidden p-3 text-xs uppercase text-gray-800">{{ menuGroup }}</p>
          <aside-menu-list
            v-else
            :key="`b-${index}`"
            :menu="menuGroup"
            @menu-click="menuClick"
          />
        </template>
      </div>
    </div>
  </aside>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import { useToast } from 'vue-toastification'
import { computed, ref, onMounted, reactive } from 'vue'
import { useStore } from 'vuex'
import { mdiMenu, mdiForwardburger } from '@mdi/js'
import AsideMenuList from '@/components/AsideMenuList'
import ShowImage from '@/components/ShowImage'
import Field from '@/components/Field'
// import Icon from '@/components/Icon'

export default {
  name: 'AsideMenu',
  components: {
    AsideMenuList,
      ShowImage,
    Field,
    },
  props: {
    menu: {
      type: Array,
      default: () => []
    }
  },
  setup () {
    const store = useStore()
    const rowData = reactive([])
    const toast = useToast()
    const isFullScreen = computed(() => store.state.isFullScreen)
    const schoolidentity = reactive({
        id: '',
        name: '',
        website_url: '',
        email: '',
        address1: '',
        address2: '',
        address3: '',
        address4: '',
        telp1: '',
        telp2: '',
        telp3: '',
        telp4: '',
        fax1: '',
        fax2: '',
        description: '',
        file_name: '',
        // department_id: '',
        status: '',
        library: '',
        info1: '',
        info2: '',
        info3: '',
        created_by: '',
        updated_by: ''
    })

    const getData = async () => {
            await axios
            .get('/get-menu')
            .then(response => {
                // assign state kelass with response data
                rowData.value = response.data.data
                Object.assign(schoolidentity, response.data.data)
                // filteredData.value = response.data.data
                // filterData()
                console.log('rowData.value', rowData.value)
            }).catch(error => {
                // toast.error(error.response.data, { timeout: 5000 })
                console.log(error)
            })
        }
    const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded)

    const isAsideLgActive = computed(() => store.state.isAsideLgActive)

    const asideLgClose = () => {
      store.dispatch('asideLgToggle', false)
    }

    const menuClick = (event, item) => {
      //
    }
    onMounted(()=>{
      // getData()
    })

    const darkMode = computed(() => store.state.darkMode)

    return {
      // classDark,
      darkMode,
      isFullScreen,
      isAsideMobileExpanded,
      isAsideLgActive,
      asideLgClose,
      menuClick,
      rowData,
      mdiMenu,
      mdiForwardburger,
      schoolidentity,
      getData
    }
  }
}
</script>
